export const AppCypressAttribute = {
  buttons: {
    COLLAPSE_TRIGGER: 'AppCypressAttribute:buttons:COLLAPSE_TRIGGER',
    COLLAPSE_TRIGGER_ICON: 'AppCypressAttribute:buttons:COLLAPSE_TRIGGER_ICON',
    DROPDOWN_ITEM: 'AppCypressAttribute:buttons:DROPDOWN_ITEM',
    VIDEO_PLAY: 'AppCypressAttribute:buttons:VIDEO_PLAY',
    VIDEO_PAUSE: 'AppCypressAttribute:buttons:VIDEO_PAUSE',
    VIDEO_REPLAY: 'AppCypressAttribute:buttons:VIDEO_REPLAY',
    TABS_LEFT_ARROW: 'AppCypressAttribute:buttons:TABS_LEFT_ARROW',
    TABS_RIGHT_ARROW: 'AppCypressAttribute:buttons:TABS_RIGHT_ARROW'
  },
  inputs: {},
  views: {
    VERTICAL_PROGRESS_BAR: 'AppCypressAttribute:views:VERTICAL_PROGRESS_BAR',
    UNREAD_BADGE: 'AppCypressAttribute:views:UNREAD_BADGE',
    VIDEO_PLAYER: 'AppCypressAttribute:views:VIDEO_PLAYER',
    LOADING: 'AppCypressAttribute:views:LOADING',
    LAYOUT_APP_CONTAINER: 'AppCypressAttribute:views:LAYOUT_APP_CONTAINER',
    OPS_LAYOUT_APP_CONTAINER: 'AppCypressAttribute:views:OPS_LAYOUT_APP_CONTAINER',
    VIDEO_OVERLAY: 'AppCypressAttribute:views:VIDEO_OVERLAY'
  },
  status: {
    buttons: {},
    inputs: {},
    views: {
      TEXT: 'AppCypressAttribute:status:views:TEXT'
    }
  }
};
